import { render, staticRenderFns } from "./question-three.vue?vue&type=template&id=30b51a9e&"
import script from "./question-three.vue?vue&type=script&lang=js&"
export * from "./question-three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports